import http from "./http.service";

export const getPaymentHistory = async (year:any) => {
    return http.get(`/partner/payment-history?year=${year}`,{});
}

export const getClassDetails = async (id:any) => {
    return http.get(`/partner/class/${id}`);
}

export const getMonthlyPaymentHistory = async (payload: any) => {
    return http.get(`/partner/class-payment-history`,{ params: payload });
}

export const getClassMonthlyPaymentHistory = async (payload: any) => {
    return http.get(`/partner/class-booking-details`,{ params: payload });
}